import React, { useState } from "react";
import SubscribeImg from "../assets/SubscribeModalImg.svg";
import { GoArrowRight } from "react-icons/go";
import axiosStrapiInstance from "../axiosStrapi";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";

const Subscribe = ({ setOpenModal }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const handleClose = (e) => {
    // Close if clicking outside the container
    if (e.target.id === "overlay") {
      setIsOpen(false);
      setOpenModal(false);
    }
  };

  const handleCloseModal=()=>{
    setIsOpen(false);
    setOpenModal(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = { data: { email: email, FormType: "Subscribe" } };
      const response = await axiosStrapiInstance.post(
        "/api/enquiry-forms",
        payload
      );
      setEmail("");
      toast.success("Subscribed Successfully");
    } catch (error) {
      console.log("error while submiting form", error);
      toast.error(error?.response?.data?.error?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-50"
          style={{ background: "rgba(0, 0, 0, 0.2)" }}
          onClick={handleClose}
        >
          <div className="bg-white py-[1.3rem] relative sm:py-[3rem] px-[1rem] sm:px-[0.5rem] w-[350px] lg:w-[580px] sm:h-[450px] shadow-lg flex  gap-3 sm:gap-5 flex-col items-center justify-center rounded-[16px]">
             <RxCross2
                          onClick={handleCloseModal}
                          className="absolute w-7 h-7 cursor-pointer text-[#d31c4f] top-[5%] right-[5%] "
                        />
            <img src={SubscribeImg} alt="subscribeImg" />
            <h1 className="font-Lato font-semibold text-[40px] leading-[48px] text-black">
              Subscribe
            </h1>
            <p className="font-medium text-2xl leading-7 text-[#7D7D7D]">
              Subscribe to our newsletter & stay updated
            </p>
            <div className="flex sm:px-[1.5rem] self-stretch gap-3 items-center justify-between">
              <input
                name="email"
                placeholder="Enter Email Address"
                type="text"
                value={email}
                className="rounded-xl w-[67%]  outline-none border border-[#e8e8e8] bg-[#ececec] p-3"
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                className="bg-[#d31c4f] w-[30%] py-3 px-8 items-center flex justify-center rounded-xl text-white"
                onClick={handleSubmit}
                disabled={loading}
              >
                Submit <GoArrowRight className="text-white w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Subscribe;
